export type AuthenticationUploadIds = {
  bagId: string;
  authenticationBagId: number;
};

export class AuthenticationUploadIdError extends Error {}

type AuthenticationUploadResponseIds = {
  bagId?: string | number;
  authenticationBagId?: number;
};

export const getAuthenticationUploadIds = (
  bagId: string | undefined,
  authenticationBagId: number | undefined,
): AuthenticationUploadIds | undefined => {
  if (!bagId && !authenticationBagId) {
    return undefined;
  }
  if (!bagId || !authenticationBagId) {
    throw new AuthenticationUploadIdError(
      'AI authentication upload session has incomplete IDs',
    );
  }

  return { bagId, authenticationBagId };
};

export const lockAuthenticationUploadIds = (
  lockedIds: AuthenticationUploadIds | undefined,
  responseIds: AuthenticationUploadResponseIds,
): AuthenticationUploadIds => {
  const { bagId, authenticationBagId } = responseIds;
  if (!bagId || !authenticationBagId) {
    throw new AuthenticationUploadIdError(
      'AI authentication upload response is missing IDs',
    );
  }

  const normalizedIds = {
    bagId: String(bagId),
    authenticationBagId,
  };
  if (!lockedIds) {
    return normalizedIds;
  }

  if (
    lockedIds.bagId !== normalizedIds.bagId ||
    lockedIds.authenticationBagId !== normalizedIds.authenticationBagId
  ) {
    throw new AuthenticationUploadIdError(
      'AI authentication upload IDs changed',
    );
  }

  return lockedIds;
};
